<template>
  <div class="m-l-10">
      <b-button-group size="xs" :title="inactive ? 'When search is active, tabs will be inactive': ''">
          <b-button :variant="inactive ? 'outline-default' : 'dark'" :pressed="activeTab == 'initial' ? true : false" @click="changeTab('initial')" :disabled="activeTab == 'initial' || inactive">Initial</b-button>
          <b-button :variant="inactive ? 'outline-default' : 'dark'" :pressed="activeTab == 'sent' ? true : false" @click="changeTab('sent')" :disabled="activeTab == 'sent' || inactive">Sent</b-button>
      </b-button-group>
  </div>
</template>

<script>
import EventBus from '../../EventBus'

  export default {
     props: {
       inactive: {
         type: Boolean,
         default: false
       }
     },
     data(){
       return {
         activeTab: 'initial',
       }
     },
     methods: {
       changeTab(tabname){
         this.activeTab = tabname;

         EventBus.$emit('items-list.tab-changed', tabname)
       }
     }
  }
</script>

<style lang="scss" scoped>

</style>